// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JG2t","colMin":"styles_colMin__3uTE0"};